<template>
  <div
    class="wysiwyg-content"
    v-html="widget.widgetSettings.wysiwygContent"
  />
</template>

<script>
export default {
  props: {
    'widget': {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.$eventHub.$emit('observeElement', this.$el)
  },
  beforeDestroy() {
    this.$eventHub.$emit('unobserveElement', this.$el)
  }
}
</script>
